import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { CategoryTag } from '../components'
// mui
import Divider from '@material-ui/core/Divider'

const dateToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) 
}

const MagazineCard = props => {
    const dispatch = useDispatch()
    const postDate = props.date ? dateToString(props.date.toDate()) : ''

    return (
        <>
        { (!props.isTrash && !props.isDraft) && (
        <>
            <MagazineCardWrapper>
                <FlexWrapper>
                    {props.external ? (
                        <MagazineExternalLink href={props.externalLink} target="_blank">
                            <ImageWrapper>
                                <MagazineImage src={props.image ? props.image.path : ""}/>
                            </ImageWrapper>
                            <InfoWrapper>
                                <Date>{postDate}</Date>
                                <div className='spacer-25' />
                                <Title>{props.title}</Title>
                            </InfoWrapper>
                        </MagazineExternalLink>
                    ):(
                        <MagazineLink onClick={() => dispatch(push(`/magazine/dp/${props.id}`))}>
                            <ImageWrapper>
                                <MagazineImage src={props.image ? props.image.path : ""}/>
                            </ImageWrapper>
                            <InfoWrapper>
                                <Taxonomy><CategoryTag category={props.category} /></Taxonomy>
                                <div className='spacer-25' />
                                <Date>{postDate}</Date>
                                <div className='spacer-25' />
                                <Title>{props.title}</Title>
                            </InfoWrapper>
                        </MagazineLink>
                    )}
                </FlexWrapper>

            </MagazineCardWrapper>
            <Divider />
        </>
        )}
        </>
    )
}

export default MagazineCard

const MagazineCardWrapper = styled.div`
    width: 640px;
    padding: 10px;
    font-size: .9rem;
    cursor: pointer;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 10px 20px;
    }
`

const FlexWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`
const ImageWrapper = styled.div`
    width: 240px;
    @media screen and (max-width:768px){
        width: 120px;
    }
`
const MagazineImage = styled.img`
    width: 100%;
    height: 320px;
    object-fit: cover;
    @media screen and (max-width:768px){
        height: 160px;
    }
`
const InfoWrapper = styled.div`
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    @media screen and (max-width:768px){
        max-width: 240px;
    }
`
const Taxonomy = styled.p`
    font-size: .9rem;
    @media screen and (max-width:768px){
        font-size: .8rem;
    }
`
const Date = styled.span`
    color: #ccc;
    &:before {
        content: '';
        width: 50px;
        height: 5px;
        display: block;
        background-color: #fff;
        margin-bottom: 50px;
    }
    @media screen and (max-width:768px){
        &:before {
            width: 30px;
            height: 3px;
            margin-bottom: 20px;
        }
    }
`
const Title = styled.h3`
    width: 100%;
    font-size: 1.5rem;
    text-align: left;
    @media screen and (max-width:768px){
        font-size: 1rem;
    }
`
const MagazineLink = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`
const MagazineExternalLink = styled.a`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`